/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Recordsdescription1Inputs */

const zh_learn_recordsdescription1 = /** @type {(inputs: Learn_Recordsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看这个学习资源的详细作答记录。`)
};

const en_learn_recordsdescription1 = /** @type {(inputs: Learn_Recordsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View detailed attempt records for this learning resource.`)
};

const es_learn_recordsdescription1 = /** @type {(inputs: Learn_Recordsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta registros detallados de intentos para este recurso de aprendizaje.`)
};

/**
* | output |
* | --- |
* | "View detailed attempt records for this learning resource." |
*
* @param {Learn_Recordsdescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_recordsdescription1 = /** @type {((inputs?: Learn_Recordsdescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Recordsdescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_recordsdescription1(inputs)
	if (locale === "en") return en_learn_recordsdescription1(inputs)
	return es_learn_recordsdescription1(inputs)
});
export { learn_recordsdescription1 as "learn_recordsDescription" }